const Joi = require("joi");
const ValidationTranslateFile = require("../Loc/ValidationTranslateFile.jsx");
const currentLang = ValidationTranslateFile()

const RequestRemedyFormSchema = (data) => {

    const schema = Joi.object({
        grievanceDescription: Joi.string()
            .trim()
            .required()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Grievance_Description_Required,
                "any.required": currentLang?.ValidationSchema?.Grievance_Description_Required,
            }),

    }).unknown(true);

    return schema.validate(data, {
        abortEarly: false,
    });
};

module.exports = RequestRemedyFormSchema;
